<template>
  <div class="table-responsive">
    <div>
      <h3>
        Histórico de processamento
        <a href="#" @click.prevent="callData" title="Recarregar lista">
          <i class="fas fa-sync-alt"></i>
        </a>
      </h3>
    </div>
    <div class="container-table">
      <table class="table table-striped- table-bordered table-hover table-checkable">
        <thead>
          <tr>
            <td nowrap class="text-center" width="100">Mês</td>
            <td nowrap class="text-center" width="100">
              Clientes (IDs)
            </td>
            <td nowrap class="text-center" width="100">Status</td>
            <td nowrap class="text-center" width="60">Usuário</td>
            <td nowrap class="text-center" width="100">Data</td>
            <td nowrap class="text-center" width="100">Log</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-if="loading" class="text-center" colspan="5">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </td>
          </tr>
          <tr v-for="(history, id) in data" :key="id">
            <td class="text-center">
              {{ history.billing_month | month }}
            </td>
            <td class="text-center">
              {{ history.customers_param ? history.customers_param : 'Todos' }}
            </td>
            <td class="text-center font-weight-bold" :class="'status-' + history.status">
              {{ history.status | invoice_history_status }}
            </td>
            <td class="text-center">
              {{ history.user_id ? history.user.name : 'Automático' }}
            </td>
            <td class="text-center">
              {{ history.created_at | date }}
            </td>
            <td class="text-center">
              <a
                v-if="history.log.length > 0"
                href="#"
                @click.prevent.stop="openLogBugContract(history)"
                class="icon-circle ml-1"
                v-b-tooltip.hover
                title="Ver Log de Bug"
              >
                <i class="m-menu__link-icon far fa-bug"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <transition name="slideleft" mode="out-in">
          <LogBillingHistoryModal v-if="showLogError" />
        </transition>
        <transition name="fade" mode="out-in">
          <div class="m-quick-sidebar-overlay" v-if="showLogError" @click="closeLogError()"></div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { returnMessageMixin } from '@/mixins/returnMessageMixin';
import { baseApiUrl } from '@/global';
import axios from 'axios';
import LogBillingHistoryModal from '@/components/invoices/LogBillingHistoryModal';

export default {
  mixins: [returnMessageMixin],
  name: 'InvoiceProccessHistory',
  components: { LogBillingHistoryModal },
  computed: {
    showLogError() {
      return this.$store.state.showLogError;
    },
  },
  data() {
    return {
      data: [],
      loading: true,
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
    };
  },
  methods: {
    closeLogError() {
      this.$store.state.showLogError = null;
    },
    openLogBugContract(history) {
      this.$store.state.showLogError = history.log;
    },
    callData() {
      this.data = [];
      this.loading = true;
      this.getDatas();
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/invoice/get-process-history/1`;
      axios(url)
        .then((res) => {
          this.data = res.data.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getDatas();
  },
};
</script>
<style scoped>
.status-queued {
  color: #ffc94f;
}
.status-finished {
  color: #00d86b;
}
.status-processing {
  color: #7592ff;
}
.status-error {
  color: #ff7575;
}
</style>
